import { useState } from 'react'
import styled from 'styled-components'
import { Button, Icon } from 'react-materialize'
import ConciliateTransactionsModal from '../Shared/Modals/ConciliateTransactions/ConciliateTransactionsModal.react'

const StyledIcon = styled(Icon)`
  /* Override materialize css nav i selector */
  && {
    font-size: 1.8rem;
  }
  margin-right: 0.4rem;
`

const StyledButton = styled(Button)`
  background-color: #07bb9c;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 8px;
`

const ConciliateTransactionsButton = () => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen(!open)
  }

  return (
    <>
      <StyledButton onClick={handleToggle}>
        <StyledIcon>add</StyledIcon>Add Transactions
      </StyledButton>
      <ConciliateTransactionsModal handleToggle={handleToggle} open={open} />
    </>
  )
}

export default ConciliateTransactionsButton
